var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGuide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 62,
    viewBox: "0 0 63 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.9883 3.76824C28.9883 3.03707 29.5806 2.44434 30.3113 2.44434H45.8263C46.5569 2.44434 47.1493 3.03707 47.1493 3.76824V59.8536C47.1493 60.5848 46.5569 61.1775 45.8263 61.1775H30.3113C29.5806 61.1775 28.9883 60.5848 28.9883 59.8536V3.76824ZM31.6343 5.09214V58.5297H44.5033V5.09214H31.6343Z",
    fill: "#664BF0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.5039 3.76824C44.5039 3.03707 45.0962 2.44434 45.8269 2.44434H61.4622C62.1928 2.44434 62.7852 3.03707 62.7852 3.76824V59.8536C62.7852 60.5848 62.1928 61.1775 61.4622 61.1775H45.8269C45.0962 61.1775 44.5039 60.5848 44.5039 59.8536V3.76824ZM47.1499 5.09214V58.5297H60.1392V5.09214H47.1499Z",
    fill: "#664BF0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.41327 2.07647C6.48276 1.35709 7.11594 0.826412 7.83587 0.884185L24.1627 2.19441C24.5162 2.22278 24.8435 2.39197 25.0712 2.66403C25.2989 2.93609 25.4079 3.28823 25.3738 3.64146L19.9315 59.9812C19.862 60.7006 19.2288 61.2313 18.5089 61.1735L2.18208 59.8633C1.82859 59.8349 1.50128 59.6657 1.27358 59.3936C1.04588 59.1216 0.936865 58.7694 0.970986 58.4162L6.41327 2.07647ZM8.92173 3.62763L3.73407 57.3315L17.4231 58.43L22.6107 4.72617L8.92173 3.62763Z",
    fill: "#664BF0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.6433 16.4053C54.374 16.4053 54.9663 16.998 54.9663 17.7292V22.423C54.9663 23.1542 54.374 23.7469 53.6433 23.7469C52.9126 23.7469 52.3203 23.1542 52.3203 22.423V17.7292C52.3203 16.998 52.9126 16.4053 53.6433 16.4053Z",
    fill: "#664BF0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.1296 16.4053C38.8603 16.4053 39.4526 16.998 39.4526 17.7292V22.423C39.4526 23.1542 38.8603 23.7469 38.1296 23.7469C37.399 23.7469 36.8066 23.1542 36.8066 22.423V17.7292C36.8066 16.998 37.399 16.4053 38.1296 16.4053Z",
    fill: "#664BF0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuide);
export default __webpack_public_path__ + "static/media/guide.1248a783267fefce5e71ed1cfceb133f.svg";
export { ForwardRef as ReactComponent };